<template>
  <vs-row vs-justify="center" id="organization-box">
    <vs-col type="flex" vs-lg="12" vs-xs="12">
      <vs-card id="form" fixedHeight>
        <vs-tabs :value="activeTab">
          <vs-tab
            :label="$t('Company.Tabs.BasicInformation')"
            icon="info"
            id="information-tab"
          >
            <vs-row class="mt-4">
              <vs-col vs-lg="4" vs-xs="12" vs-sm="6" align="center">
                <img
                  :src="organization_info.logo"
                  width="250"
                  class=""
                  alt="user"
                  v-if="organization_info.logo"
                />
                <vs-avatar size="100px" icon="home" v-else></vs-avatar>
                <vs-input
                  type="file"
                  class="w-75 mt-4"
                  @change="handleChangePhoto"
                  id="fileInput"
                  :label="$t('Organization.Logo')"
                  v-model="photo"
                />
              </vs-col>
              <vs-col vs-lg="8" vs-xs="12" vs-sm="6">
                <vs-row>
                  <vs-col vs-w="6">
                    <vs-input
                      :danger="errors.name"
                      :danger-text="
                        $t('Errors.InvalidPolite', {
                          field: $t('Organization.Name'),
                        })
                      "
                      :label="$t('Organization.Name')"
                      placeholder="12n"
                      v-model="organization_info.name"
                      class="w-100 mb-2"
                    />
                  </vs-col>
                  <vs-col vs-w="6">
                    <vs-input
                      :label="$t('Organization.Email')"
                      placeholder="12n"
                      v-model="organization_info.email"
                      class="w-100 mb-2"
                    />
                  </vs-col>
                </vs-row>

                <vs-row>
                  <vs-col vs-w="8">
                    <vs-input
                      :danger="errors.address"
                      :danger-text="
                        $t('Errors.InvalidPolite', {
                          field: $t('Organization.Address'),
                        })
                      "
                      :label="$t('Organization.Address')"
                      placeholder="1, Building name, Street Name"
                      v-model="organization_info.address"
                      class="w-100 mb-2 mt-2"
                    />
                  </vs-col>
                  <vs-col vs-w="4">
                    <vs-input
                      :danger="errors.phone"
                      :danger-text="
                        $t('Errors.InvalidPolite', {
                          field: $t('Organization.Phone'),
                        })
                      "
                      :label="$t('Organization.Phone')"
                      :placeholder="$t('Organization.Phone')"
                      v-model="organization_info.phone"
                      class="w-100 mt-2"
                    />
                  </vs-col>
                  <vs-col vs-w="4">
                    <label class="vs-input--label" for="color-add-edit">{{
                      $t("Department.Color")
                    }}</label>
                    <input
                      id="color-add-edit"
                      v-model="organization_info.template"
                      type="color"
                      class="w-100"
                    />
                  </vs-col>
                </vs-row>
              </vs-col>
            </vs-row>
            <br />
            <vs-row>
              <GmapMap
                :center="currentLocation"
                :zoom="16"
                map-type-id="terrain"
                style="width: 100%; height: 400px"
                :options="{
                  zoomControl: true,
                  mapTypeControl: false,
                  streetViewControl: false,
                  rotateControl: false,
                  fullscreenControl: true,
                  disableDefaultUi: false,
                }"
              >
                <GmapMarker
                  :key="index"
                  v-for="(m, index) in markers"
                  :position="m.position"
                  :clickable="true"
                  :draggable="true"
                  @click="center = m.position"
                  @dragend="updateCoordinates"
                />
              </GmapMap>
            </vs-row>
            <vs-row class="float-right m-4">
              <vs-button color="primary" @click="updateOrganization">{{
                $t("Organization.UpdateButton")
              }}</vs-button>
            </vs-row>
          </vs-tab>
          <vs-tab
            :label="$t('Company.Tabs.WorkingDays')"
            icon="calendar_today"
            id="working-days-tab"
            @click="resetVariables"
          >
            <BusinessSelectFilterAll
              :multiselect="true"
              v-on:selectBusiness="filterByBuisiness"
              @selectChangeAll="fillItems"
            ></BusinessSelectFilterAll>
            <WorkingDay
              :key="index"
              v-for="(day, index) in workingDays"
              :day="day"
            ></WorkingDay>
            <div class="btn-alignment mt-4">
              <vs-button color="primary" @click="updateWorkingDays">{{
                $t("Company.UpdateButton")
              }}</vs-button>
            </div>
          </vs-tab>
          <vs-tab
            :label="$t('Company.Tabs.BookingWorkingDays')"
            icon="calendar_today"
            id="book-working-days-tab"
            @click="resetVariables"
          >
            <BusinessSelectFilterAll
              :multiselect="true"
              v-on:selectBusiness="filterByBuisiness"
              @selectChangeAll="fillItems"
            ></BusinessSelectFilterAll>
            <WorkingDay
              :key="index"
              v-for="(day, index) in workingDaysBooking"
              :day="day"
            ></WorkingDay>
            <div class="btn-alignment mt-4">
              <vs-button color="primary" @click="updateWorkingDaysBooking">{{
                $t("Company.UpdateButton")
              }}</vs-button>
            </div>
          </vs-tab>
          <vs-tab
            :label="$t('Company.Tabs.Maintenance')"
            icon="calendar_today"
            id="book-working-days-tab"
            @click="resetVariables"
          >
            <h5 class="mt-3">
              Veuillez sélectionner l'agances(s) ou la requete de maintenence va
              etre envoyer
            </h5>
            <BusinessSelectFilterAll
            class="mt-3"
              :multiselect="true"
              v-on:selectBusiness="filterByBuisiness"
              @selectChangeAll="fillItems"
            ></BusinessSelectFilterAll>
            <h5 class="mt-4">
              Veuillez sélectionner l'application(s) ou la requete de
              maintenence va etre envoyer
            </h5>
            <vs-select
              class="w-100 mb-2 mt-2"
              :label="$t('Company.Tabs.App')"
              multiple
              v-model="maintenance.target"
              
            >
              <vs-select-item
                :key="index"
                :value="item.value"
                :text="item.text"
                v-for="(item, index) in apps"
              />
            </vs-select>

            <vs-checkbox
              class="justify-content-start w-100 mb-4 mt-4"
              v-model="maintenance.status"
              >{{ $t("Company.Tabs.UnderMaintenance") }}</vs-checkbox
            >

            <div class="btn-alignment mt-4">
              <vs-button color="primary" @click="changeMaintenanceStatus">{{
                $t("Company.UpdateButton")
              }}</vs-button>
            </div>
          </vs-tab>
        </vs-tabs>
      </vs-card>
    </vs-col>
  </vs-row>
</template>

<script>
import { mapState, mapActions } from "vuex";
import {
  helpersService,
  businessService,
  organizationService,
} from "../../_services";
import { gmapApi } from "vue2-google-maps";
import router from "../../_helpers/router";
import WorkingDay from "../../components/settings/WorkingDay";
import BusinessSelectFilterAll from "../../components/shared/BusinessSelectFilterAll";

export default {
  name: "Business",
  data: () => ({
    title: "Business",
    changeAll: false,
    items: [],
    apps: [
      {text: 'Kiosks', value: "kiosks"},
      {text: 'Displays', value: "displays"},
      {text: 'Tellers', value: "tellers"}
  ],
    maintenance: {
      target: [],
      status: null,
    },
    workingDays: [
      {
        day: "Monday",
        start_time: "08:00:00",
        end_time: "16:30:00",
        active: 1,
        created_at: "2021-07-30 12:07:14",
        updated_at: "2021-10-18 18:02:33",
      },
      {
        day: "Tuesday",
        start_time: "08:00:00",
        end_time: "16:30:00",
        active: 1,
        created_at: "2021-07-30 12:07:14",
        updated_at: "2021-10-18 18:02:33",
      },
      {
        day: "Wednesday",
        start_time: "08:00:00",
        end_time: "16:30:00",
        active: 1,
        created_at: "2021-07-30 12:07:14",
        updated_at: "2021-10-18 18:02:33",
      },
      {
        day: "Thursday",
        start_time: "08:00:00",
        end_time: "16:30:00",
        active: 1,
        created_at: "2021-07-30 12:07:14",
        updated_at: "2021-10-18 18:06:06",
      },
      {
        day: "Friday",
        start_time: "08:00:00",
        end_time: "16:30:00",
        active: 1,
        created_at: "2021-07-30 12:07:14",
        updated_at: "2021-10-18 18:02:33",
      },
      {
        day: "Saturday",
        start_time: "08:00:00",
        end_time: "14:00:00",
        active: 0,
        created_at: "2021-07-30 12:07:14",
        updated_at: "2021-10-18 18:02:33",
      },
      {
        day: "Sunday",
        start_time: "09:00:00",
        end_time: "17:00:00",
        active: 0,
        created_at: "2021-07-30 12:07:14",
        updated_at: "2021-10-18 18:02:33",
      },
    ],
    workingDaysBooking: [
      {
        day: "Monday",
        start_time: "08:00:00",
        end_time: "16:15:00",
        active: 1,
        created_at: "2021-07-30 12:07:14",
        updated_at: "2021-10-18 18:02:33",
      },
      {
        day: "Tuesday",
        start_time: "08:00:00",
        end_time: "16:15:00",
        active: 1,
        created_at: "2021-07-30 12:07:14",
        updated_at: "2021-10-18 18:02:33",
      },
      {
        day: "Wednesday",
        start_time: "08:00:00",
        end_time: "16:15:00",
        active: 1,
        created_at: "2021-07-30 12:07:14",
        updated_at: "2021-10-18 18:02:33",
      },
      {
        day: "Thursday",
        start_time: "08:00:00",
        end_time: "16:15:00",
        active: 1,
        created_at: "2021-07-30 12:07:14",
        updated_at: "2021-10-18 18:06:06",
      },
      {
        day: "Friday",
        start_time: "08:00:00",
        end_time: "16:15:00",
        active: 1,
        created_at: "2021-07-30 12:07:14",
        updated_at: "2021-10-18 18:02:33",
      },
      {
        day: "Saturday",
        start_time: "08:00:00",
        end_time: "14:00:00",
        active: 0,
        created_at: "2021-07-30 12:07:14",
        updated_at: "2021-10-18 18:02:33",
      },
      {
        day: "Sunday",
        start_time: "09:00:00",
        end_time: "17:00:00",
        active: 0,
        created_at: "2021-07-30 12:07:14",
        updated_at: "2021-10-18 18:02:33",
      },
    ],
    filter: {
      agency: [],
    },
    activeTab: 0,
    business: {},
    photo: "",
    currentLocation: { lat: 0, lng: 0 },
    markers: [],
    errors: {
      name: false,
      address: false,
      postal_code: false,
      city: false,
      phone: false,
      industry: false,
    },
    countries: [],
    cities: [],
    industries: [],
    steps: [
      {
        target: ".vs-card--content", // We're using document.querySelector() under the hood
        params: {
          placement: "auto", // Any valid Popper.js placement. See https://popper.js.org/popper-documentation.html#Popper.placements
        },
      },
      {
        target: "#information-tab", // We're using document.querySelector() under the hood
        params: {
          placement: "top-start", // Any valid Popper.js placement. See https://popper.js.org/popper-documentation.html#Popper.placements
        },
      },
      {
        target: "#working-days-tab", // We're using document.querySelector() under the hood
        params: {
          placement: "top-start", // Any valid Popper.js placement. See https://popper.js.org/popper-documentation.html#Popper.placements
        },
      },
      {
        target: "#location-tab", // We're using document.querySelector() under the hood
        params: {
          placement: "top-start", // Any valid Popper.js placement. See https://popper.js.org/popper-documentation.html#Popper.placements
        },
      },
    ],
    languages: [],
    business_translations: {
      ar: "",
      fr: "",
      en: "",
      de: "",
      es: "",
      ru: "",
      pt: "",
    },
  }),
  components: {
    WorkingDay,
    BusinessSelectFilterAll,
  },
  methods: {
    resetVariables() {
      this.filter.agency = [];
      this.items = [];
    },
    fillItems(items, checkValue) {
      this.items = items;
      this.changeAll = checkValue;
    },
    updateWorkingDays() {
      if (this.filter.agency.length || this.items.length) {
        this.showLoading();
        // this.themeColorControl(this.organization_info.template);
        let workingDays = new FormData();
        if (this.changeAll) {
          workingDays.append(
            "agencies",
            this.items.map((el) => {
              return el.id;
            })
          );
        } else {
          workingDays.append("agencies", this.filter.agency.join(","));
        }
        workingDays.append("working_days", JSON.stringify(this.workingDays));
        workingDays.append("_method", "POST");

        businessService
          .updateAgenciesWorkingDays(workingDays)
          .then(
            function () {
              this.notify(
                this.$t("Toasts.Successful"),
                this.$t("Organization.EditBasic.ToastSuccess"),
                "success"
              );
            }.bind(this)
          )
          .catch(
            function (err) {
              this.notify(
                this.$t("Toasts.Error"),
                this.$t("Organization.EditBasic.ToastFail"),
                "danger"
              );
              console.log(err);
            }.bind(this)
          )
          .finally(
            function () {
              this.hideLoading();
            }.bind(this)
          );
      }
    },
    updateWorkingDaysBooking() {
      if (this.filter.agency.length || this.items.length) {
        this.showLoading();
        // this.themeColorControl(this.organization_info.template);
        let workingDaysBooking = new FormData();
        if (this.changeAll) {
          workingDaysBooking.append(
            "agencies",
            this.items.map((el) => {
              return el.id;
            })
          );
        } else {
          workingDaysBooking.append("agencies", this.filter.agency.join(","));
        }
        workingDaysBooking.append(
          "working_days",
          JSON.stringify(this.workingDaysBooking)
        );
        workingDaysBooking.append("_method", "POST");

        businessService
          .updateAgenciesBookingDays(workingDaysBooking)
          .then(
            function () {
              this.notify(
                this.$t("Toasts.Successful"),
                this.$t("Organization.EditBasic.ToastSuccess"),
                "success"
              );
            }.bind(this)
          )
          .catch(
            function (err) {
              this.notify(
                this.$t("Toasts.Error"),
                this.$t("Organization.EditBasic.ToastFail"),
                "danger"
              );
              console.log(err);
            }.bind(this)
          )
          .finally(
            function () {
              this.hideLoading();
            }.bind(this)
          );
      }
    },
    ...mapActions("account", ["updateUserObject"]),
    notify(title, text, type) {
      this.$vs.notify({
        color: type,
        title: title,
        text: text,
      });
    },
    filterByBuisiness(selected, checkValue) {
      this.reloadComponents = true;
      this.filter.agency = selected.map((obj) => {
        return obj.id;
      });
      this.$nextTick(() => {
        this.reloadComponents = false;
      });
      this.changeAll = checkValue;
    },
    // validateUpdateOrganizationFields() {
    //   this.errors.organization_info.name =
    //     !this.organization_info.fname || this.organization_info.name.length < 3 ? true : false;
    //   this.errors.organization_info.phone =
    //     !this.organization_info.phone ||
    //     this.organization_info.phone.length < 3 ||
    //     !this.isValidPhoneNumber(this.organization_info.phone)
    //       ? true
    //       : false;
    //   if (this.organization_info.email && this.organization_info.email.length > 0)
    //     this.errors.organization_info.email = this.isValidEmail(this.organization_info.email)
    //       ? false
    //       : true;
    //   else this.errors.selected.organization_info = false;

    //   let { name, phone, email } = this.errors.organization_info;

    //   return !(name || phone || email);
    // },
    // isValidPhoneNumber(value) {
    //   // let phoneNumber = this.phone_number;
    //   return /^[+\d]\d+$/.test(value);
    // },
    // isValidEmail: function(value) {
    //   let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    //   return re.test(value);
    // },
    showLoading() {
      this.$vs.loading({
        container: "#organization-box",
        scale: 0.6,
      });
    },
    handleChangePhoto(event) {},
    hideLoading() {
      this.$vs.loading.close("#organization-box > .con-vs-loading");
    },
    updateOrganization() {
      this.showLoading();
      // this.themeColorControl(this.organization_info.template);
      let organization = new FormData();
      organization.append("name", this.organization_info.name);
      organization.append("address", this.organization_info.address);
      organization.append("phone", this.organization_info.phone);
      organization.append("template", this.organization_info.template);
      organization.append("email", this.organization_info.email);
      organization.append("_method", "PUT");
      if (document.getElementById("fileInput").files[0]) {
        organization.append(
          "logo",
          document.getElementById("fileInput").files[0]
        );
      }

      organizationService
        .update(organization)
        .then(
          function (data) {
            this.notify(
              this.$t("Toasts.Successful"),
              this.$t("Organization.EditBasic.ToastSuccess"),
              "success"
            );
            let userOld = JSON.parse(localStorage.getItem("user"));
            userOld.organization = data.organization;
            localStorage.setItem("user", JSON.stringify(userOld));
            this.updateUserObject();
          }.bind(this)
        )
        .catch(
          function () {
            this.notify(
              this.$t("Toasts.Error"),
              this.$t("Organization.EditBasic.ToastFail"),
              "danger"
            );
          }.bind(this)
        )
        .finally(
          function () {
            this.hideLoading();
          }.bind(this)
        );
    },
    changeMaintenanceStatus() {
      if (this.filter.agency.length || this.items.length) {
        this.showLoading();
        // this.themeColorControl(this.organization_info.template);
        let form = new FormData();
        if (this.changeAll) {
          form.append(
            "business_ids",
            this.items.map((el) => {
              return el.id;
            })
          );
        } else {
          form.append("business_ids", this.filter.agency.join(","));
        }
        form.append("status", this.maintenance.status ? 1 : 0);
        form.append("target", this.maintenance.target.join(","));
        form.append("_method", "POST");

        businessService
          .changeModeMaintenanceStatus(form)
          .then(
            function () {
              this.notify(
                this.$t("Toasts.Successful"),
                this.$t("Organization.EditBasic.ToastSuccess"),
                "success"
              );
            }.bind(this)
          )
          .catch(
            function (err) {
              this.notify(
                this.$t("Toasts.Error"),
                this.$t("Organization.EditBasic.ToastFail"),
                "danger"
              );
              console.log(err);
            }.bind(this)
          )
          .finally(
            function () {
              this.hideLoading();
            }.bind(this)
          );
      }
    },
    updateCoordinates(location) {
      this.markers[0].position = {
        lat: location.latLng.lat(),
        lng: location.latLng.lng(),
      };
    },
    goToNextTab(currentStep) {
      this.$tours["SettingsBusiness"].nextStep();
      if (currentStep == 1) {
        this.activeTab = 1;
      } else if (currentStep == 2) {
        this.activeTab = 2;
      }
    },
    goToNextPage() {
      router.push({ path: "/settings/team?istour=on" });
    },
    themeColorControl(color) {
      this.$vs.theme({ primary: color });
    },
  },
  computed: {
    ...mapState({
      account_info: (state) => state.account.user.user,
      organization_info: (state) => state.account.user.organization,
    }),
    themeColor: {
      get() {
        return this.$store.state.themeColor;
      },
      set(val) {
        this.$store.commit("SET_THEME_COLOR", val);
      },
    },
    google: gmapApi,
  },
  beforeMount() {
    this.business = this.account_info;
    let location = {
      lat: parseFloat(this.organization_info.lat),
      lng: parseFloat(this.organization_info.lng),
    };
    this.markers.push({ position: location });
    this.currentLocation = location;
    this.languages = this.$i18n.availableLocales;

    helpersService.getIndustries().then(
      function (data) {
        this.industries = [];
        data.industries.forEach((obj) => {
          this.industries.push({
            value: obj.id,
            text: obj.name,
          });
          if (obj.id == this.business.industry_id) {
            this.business.industry = obj.id;
          }
        });
      }.bind(this)
    );

    helpersService.getCountries().then(
      function (data) {
        this.countries = data.countries;
        this.cities = this.countries[this.business.country];
      }.bind(this)
    );

    this.$t("Company.Content").map(
      (content, index) => (this.steps[index].content = content)
    );
    this.$route.query.istour && localStorage.getItem("skipTour") != "true"
      ? this.$tours["SettingsBusiness"].start()
      : "";
  },
  mounted() {},
};
</script>
